import { ActionTypes } from './actions';
import initialState from './initial-state';

export function wallpaperReducer(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case ActionTypes.ROTATE_WALLPAPER:
      return {
        ...state,
        creative: action.creative,
        error: false,
        isHidden: false,
        isRotationEnabled: action.isRotationEnabled,
        isRotationPaused: false,
        position: state.position + 1,
        providerName: action.providerName,
      };

    case ActionTypes.PAUSE_WALLPAPER_ROTATION:
      return {
        ...state,
        isHidden: action.isHidden,
        isRotationPaused: true,
      };

    case ActionTypes.RESUME_WALLPAPER_ROTATION:
      return {
        ...state,
        isRotationPaused: false,
      };

    case ActionTypes.WALLPAPER_BLOCKED_BY_CLIENT:
      return {
        ...state,
        blockedByClient: true,
      };

    case ActionTypes.WALLPAPER_ERROR:
      return {
        ...state,
        error: true,
      };
  }

  return state;
}
